
export const isBeta = (): boolean => window.location.hostname.split('.')[0] === 'beta';
export const isProd = (): boolean => !isBeta();
export const isLocal = (): boolean => window.location.hostname.includes('localhost');
export const isLocalOrBeta = (): boolean => isLocal() || isBeta();